export const emailTldValidator = (
	value: string | null | undefined
): boolean => {
	if (!value) return true;
	return /\.[a-z]{2,}$/i.test(value.split('@')[1] || '');
};
